import React, { useState, useEffect } from 'react';
import { SocialMediaIcon } from 'components/UI';
import { Link } from '@landing/ui';
import { isRequestedFrom } from 'utils/localised';
import { cookiesPolicyLink, policyLinks } from 'define/locale';

import * as styles from './Copyright.module.scss';

const PRIVACY_TEXT = 'Privacy Policy';
const COOKIES_TEXT = 'Cookies Policy';

export default function Copyright() {
  const currentYear = new Date().getFullYear();
  const [andersenPolicyData, setAndersenPolicyData] = useState({
    link: policyLinks.all,
    text: PRIVACY_TEXT,
  });

  useEffect(() => {
    if (isRequestedFrom('BY')) {
      setAndersenPolicyData({
        link: policyLinks.by,
        text: PRIVACY_TEXT,
      });
    }
  }, []);

  return (
    <div className={styles.wrapper}>
      <div className={styles.copyright}>
        <div className={styles.textSection}>
          <p className={styles.text}>
            <span className={styles.icon}>©</span>
            {`${currentYear} Andersen Inc. All Rights Reserved. `}
            <Link
              className={styles.link}
              href={andersenPolicyData.link}
              target="_blank"
              rel="noreferrer noopener"
            >
              {andersenPolicyData.text}
            </Link>
            {' & '}
            <Link
              className={styles.link}
              href={cookiesPolicyLink}
              target="_blank"
              rel="noreferrer noopener"
            >
              {COOKIES_TEXT}
            </Link>
            .
          </p>
          <p className={styles.text}>
            This site is protected by reCAPTCHA and the Google{' '}
            <Link
              className={styles.link}
              href="https://policies.google.com/privacy"
              rel="noreferrer noopener"
            >
              Privacy Policy
            </Link>{' '}
            and{' '}
            <Link
              className={styles.link}
              href="https://policies.google.com/terms"
              rel="noreferrer noopener"
            >
              Terms of Service
            </Link>{' '}
            apply.
          </p>
        </div>
        <div className={styles.socialSection}>
          <SocialMediaIcon />
          <Link href="https://t.me/andersen_dev_trainee" className={styles.usefullLink}>
            Contact us on Telegram
          </Link>
        </div>
      </div>
    </div>
  );
}
